module.exports = __webpack_public_path__ + "img/info-icon-without-background.3eeba00f.svg";